
export function SearchParam(key: string, defaultValue?: string): string
{

    const urlParams = new URLSearchParams(window.location.search);
    const val = urlParams.get(key) ?? defaultValue;

    return val;
}

export function SearchParamNum(key: string, defaultValue?: number): number | undefined
{
    const strVal = SearchParam(key)?.toLowerCase();

    if (strVal === undefined)
    {
        return defaultValue;
    }

    const val = Number(strVal);
    return val;
}

export function SearchParamBool(key: string, defaultValue?: boolean): boolean
{
    const strVal = SearchParam(key)?.toLowerCase();
    const val = strVal === "true";

    return val;
}